import css from "./floorplanslider.scss?inline";
import globalStyles from "../../index.scss?inline";
import { Component } from "../../utils/Component";
import { ArgSpecDictionary } from "../component-utils";

import swiperStyles from "../../../node_modules/swiper/swiper-bundle.min.css?inline";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const DEBUG_VERBOSE: boolean = false;
const CLASS_NAME: string = "HHDSFloorplanSlider";
export const HHDSFloorplanSliderTagName: string = "hhds-floorplan-slider";
const TAG_NAME: string = HHDSFloorplanSliderTagName;

export const HHDSFloorplanSliderAttrNames = {
	multiple: "multiple",
};

const Attrs = HHDSFloorplanSliderAttrNames;

export class HHDSFloorplanSlider extends Component {
	private _swiper: Swiper | null = null;
	private _prevButton: HTMLElement | null = null;
	private _nextButton: HTMLElement | null = null;

	constructor() {
		super();
		// The base class's constructor handles attachmennt of a shadow root and
		// adopted global styles. Access the shadow root via this.shadow.
		//
		// Use the constructor only for anything that will never need to be destroyed as part of the
		// component's update lifecycle. init() and destroy() are called for connectedCallback and
		// disconnectedCallback, and a destroy() init() pair is called if reinit() is utilised.
	}

	protected override init(): void {
		// The base class responds to connectedCallback() by collecting attributes into
		// this.vars, then calling init(). A call to super.init() is not required.
		DEBUG_VERBOSE && console.log(CLASS_NAME, "init");

		// const argValue = this.vars.get<number>(Attrs.myNumericArg);

		// For some components, re-assigning innerHTML may be appropriate on attribute and slot changes,
		// and without the need for a reinit(). In other cases, assigning innerHTML explicitly as part of
		// the init() routine is more appropriate.
		this.shadow.innerHTML = `
      <style>${swiperStyles}</style>
      <style>${globalStyles}</style>
			<style>${css}</style>

      <div class="${TAG_NAME}">
        <div class="swiper">
          <div class="swiper-wrapper ${
						this.vars.get<Boolean>("multiple") ? "swiper-wrapper-multiple" : ""
					}"></div>
          <slot name="tags"></slot>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev button-prev">
            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="36" height="36" transform="translate(0 0.5)" fill="black" fill-opacity="0.25"/>
              <path d="M20.9427 24.3082C21.0007 24.3662 21.0468 24.4352 21.0782 24.511C21.1097 24.5869 21.1258 24.6682 21.1258 24.7503C21.1258 24.8325 21.1097 24.9138 21.0782 24.9897C21.0468 25.0655 21.0007 25.1345 20.9427 25.1925C20.8846 25.2506 20.8157 25.2967 20.7398 25.3281C20.6639 25.3595 20.5826 25.3757 20.5005 25.3757C20.4184 25.3757 20.3371 25.3595 20.2612 25.3281C20.1853 25.2967 20.1164 25.2506 20.0583 25.1925L13.8083 18.9425C13.7502 18.8845 13.7041 18.8156 13.6726 18.7397C13.6412 18.6638 13.625 18.5825 13.625 18.5003C13.625 18.4182 13.6412 18.3369 13.6726 18.261C13.7041 18.1851 13.7502 18.1162 13.8083 18.0582L20.0583 11.8082C20.1756 11.6909 20.3346 11.625 20.5005 11.625C20.6663 11.625 20.8254 11.6909 20.9427 11.8082C21.06 11.9254 21.1258 12.0845 21.1258 12.2503C21.1258 12.4162 21.06 12.5753 20.9427 12.6925L15.1341 18.5003L20.9427 24.3082Z" fill="white"/>
            </svg>
          </div>
          <div class="swiper-button-next button-next">
            <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="36" height="36" transform="translate(0 0.5)" fill="black" fill-opacity="0.25"/>
              <path d="M22.1925 18.9425L15.9425 25.1925C15.8845 25.2506 15.8155 25.2967 15.7397 25.3281C15.6638 25.3595 15.5825 25.3757 15.5003 25.3757C15.4182 25.3757 15.3369 25.3595 15.261 25.3281C15.1852 25.2967 15.1162 25.2506 15.0582 25.1925C15.0001 25.1345 14.954 25.0655 14.9226 24.9897C14.8912 24.9138 14.875 24.8325 14.875 24.7503C14.875 24.6682 14.8912 24.5869 14.9226 24.511C14.954 24.4352 15.0001 24.3662 15.0582 24.3082L20.8668 18.5003L15.0582 12.6925C14.9409 12.5753 14.875 12.4162 14.875 12.2503C14.875 12.0845 14.9409 11.9254 15.0582 11.8082C15.1754 11.6909 15.3345 11.625 15.5003 11.625C15.6662 11.625 15.8253 11.6909 15.9425 11.8082L22.1925 18.0582C22.2506 18.1162 22.2967 18.1851 22.3282 18.261C22.3597 18.3369 22.3758 18.4182 22.3758 18.5003C22.3758 18.5825 22.3597 18.6638 22.3282 18.7397C22.2967 18.8156 22.2506 18.8845 22.1925 18.9425Z" fill="white"/>
            </svg>
          </div>
        </div>
        <slot class="slides" style="display: none;"></slot>
      </div>`;

		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		// Copy all elements in the slot into .swiper-wrapper

		this._prevButton = this.shadow.querySelector(".button-prev");
		this._nextButton = this.shadow.querySelector(".button-next");

		DEBUG_VERBOSE && console.log(CLASS_NAME, "Prev button: ", this._prevButton);
		DEBUG_VERBOSE && console.log(CLASS_NAME, "Next button: ", this._nextButton);

		this.copySlides();

		requestAnimationFrame(() => {
			this.initSwiper();
			console.log("Swiper initialised", this._swiper?.slides);
		});

		// If the component uses slots, use observeSlotChanges().
		// this.observeSlotChanges(true);
	}

	private initSwiper(): void {
		const swiperContainer = this.shadow.querySelector(".swiper") as HTMLElement;
		this._swiper = new Swiper(swiperContainer, {
			modules: [Navigation, Pagination],
			slideClass: "hhds-floorplan-slider__slide",
			slidesPerView: 1,
			speed: 700,
			spaceBetween: 0,
			pagination: {
				el: this.shadow.querySelector(".swiper-pagination") as HTMLElement,
				type: "fraction",
				renderFraction: (currentClass, totalClass) => {
					return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`;
				},
			},
			navigation: {
				nextEl: this.shadow.querySelector(".button-next") as HTMLElement,
				prevEl: this.shadow.querySelector(".button-prev") as HTMLElement,
			},

			centerInsufficientSlides: true,
			// centeredSlides: true,
			breakpoints: {
				640: {
					spaceBetween: 0,
					slidesPerView: 2,
				},
				// 1024: {
				//   slidesPerView: 1.5,
				//   spaceBetween: 24,
				// },
				// 1366: {
				//   slidesPerView: 2.5,
				//   spaceBetween: 32,
				// },
			},
		});
	}

	private copySlides() {
		const slidesEl = this.shadow?.querySelector(".slides");
		if (slidesEl && slidesEl instanceof HTMLSlotElement) {
			const swiperWrapperSelector = ".swiper-wrapper";
			const swiperWrapper = this.shadow?.querySelector(swiperWrapperSelector);

			if (!swiperWrapper)
				throw new Error(`Unable to derive selector: ${swiperWrapperSelector}`);

			const elements = slidesEl.assignedElements() as HTMLElement[];

			elements.forEach((element) => {
				const slide = document.createElement("div");
				slide.classList.add("hhds-floorplan-slider__slide");

				if (element.hasAttribute("src")) {
					const img = document.createElement("img");
					img.setAttribute("src", element.getAttribute("src") || "");
				}
				slide.appendChild(element.cloneNode(true));

				swiperWrapper.appendChild(slide);
			});
		}
	}

	protected override destroy(): void {
		// The base class responds to disconnectedCallback() by collecting attributes into
		// this.vars, then calling destroy(). A call to super.destroy() is not required.
		DEBUG_VERBOSE && console.log(CLASS_NAME, "destroy");
		// If the component uses slots, stop observing slot changes.
		// this.observeSlotChanges(false);
	}

	override onAttributeChanged(
		name: string,
		_oldValue: string,
		newValue: string
	): void {
		DEBUG_VERBOSE &&
			console.log(CLASS_NAME, "Attribute changed: ", name, _oldValue, newValue);
		// Either call reinit() to have the component's destroy and init methods each be called,
		// or skip this step and handle update of the attribute directly. 'this.vars' will already
		// have been updated by the base Component class, so it can be immediately used to access
		// the new value.
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, elements: Element[]): void {
		if (elements.length == 0) {
			DEBUG_VERBOSE && console.log(CLASS_NAME, "Slot emptied");
		} else {
			DEBUG_VERBOSE && console.log(CLASS_NAME, "Slot changed");
		}
	}

	static override argSpecs(): ArgSpecDictionary {
		// The base Component class must have access to this superclass's ArgSpecs.
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	[Attrs.multiple]: {
		description: "Wheter the component contains multiple slides.",
		defaultValue: true,
		type: Boolean,
	},
};
